var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
const IconSvg = (_a) => {
    var { type, className } = _a, props = __rest(_a, ["type", "className"]);
    let icon;
    switch (type) {
        case 'cart':
            icon = '../../_svg/cart.svg';
            break;
        case 'notifications':
            icon = '../../_svg/notifications.svg';
            break;
        case 'profile':
            icon = '../../_svg/profile.svg';
            break;
        case 'settings':
            icon = '../../_svg/settings.svg';
            break;
        default:
            icon = '../../_svg/cart.svg';
    }
    const { id, viewBox, } = icon;
    return (<div className={`icon-svg ${className}`}>
      <svg className="icon-svg__glyph" viewBox={viewBox} {...props}>
        <use xlinkHref={`#${id}`}/>
      </svg>
    </div>);
};
export default IconSvg;



// WEBPACK FOOTER //
// ./components/icon-svg/index.tsx